import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const HorizontalRule = styled.hr<{
  spacing?: 'small' | 'medium' | 'big';
  noBottomSpacing?: boolean;
  noTopSpacing?: boolean;
}>`
  border: none;
  height: 1px;
  width: 100%;
  background-color: ${({ theme }): string => theme.palette_gray_10};
  flex-shrink: 0;

  ${({
    theme,
    spacing = 'medium',
    noBottomSpacing = false,
    noTopSpacing = false
  }): FlattenSimpleInterpolation | undefined => {
    if (spacing === 'small') {
      return css`
        margin-top: ${noTopSpacing === true ? 0 : theme.spacing_unit_x1};
        margin-bottom: ${noBottomSpacing === true ? 0 : theme.spacing_unit_x1};
      `;
    }

    if (spacing === 'medium') {
      return css`
        margin-top: ${noTopSpacing === true ? 0 : theme.spacing_unit_x2};
        margin-bottom: ${noBottomSpacing === true ? 0 : theme.spacing_unit_x2};
      `;
    }

    if (spacing === 'big') {
      return css`
        margin-top: ${noTopSpacing === true ? 0 : theme.spacing_unit_x4};
        margin-bottom: ${noBottomSpacing === true ? 0 : theme.spacing_unit_x4};
      `;
    }

    return;
  }}
`;
